import script from "./GridItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GridItem.vue?vue&type=script&setup=true&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=dc41716c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc41716c"]])

export default __exports__